/**
 * A/B Test — Bundle pack messaging + Pack of 6 + Air Pump gift
 * Toggle: body[data-bundle-messaging-airpump-ab="true|false"]
 *   - false (control): show 1 / 2 / 4 Pack; hide 6 Pack
 *   - true  (variant): hide 1 Pack; show 2 / 4 / 6
 *       2 Pack → "Buy 1 Get 1 FREE"
 *       4 Pack → "Buy 2 Get 2 FREE"
 *       6 Pack → "Buy 3 Get 3 FREE"
 *       2 / 4 / 6 Pack gifts → Free Shipping (+ Luggage) + Free Air Pump
 *
 * Skipped when data-bundle-selector-ab or data-bundle-messaging-ab is true.
 */
(function () {
  'use strict';

  if (window.__bundleMessagingAirpumpAbInit) return;
  window.__bundleMessagingAirpumpAbInit = true;

  var ATTR = 'data-bundle-messaging-airpump-ab';
  var PACK_ATTR = 'data-pack-type';
  var ORIGINAL_ATTR = 'data-bundle-messaging-airpump-ab-original';
  var BADGE_ORIGINAL_ATTR = 'data-bundle-messaging-airpump-ab-badge-original';
  var GIFT_ATTR = 'data-bundle-airpump-gift';
  var PACK6_GIFTS_ATTR = 'data-bundle-messaging-airpump-ab-pack6-gifts';
  var SIX_HIDDEN_CLASS = 'bundle-messaging-airpump-ab__six-hidden';
  var ONE_HIDDEN_CLASS = 'bundle-messaging-airpump-ab__one-hidden';
  var PACK6_CARD_CLASS = 'bundle-messaging-airpump-ab__pack6-card';
  var VARIANT_B_BADGE = '50% OFF';
  var GIFT_TEXT = '+ Free Air Pump';
  var SHIPPING_ICON_URL = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame_2.png?v=1780054692';
  var LUGGAGE_ICON_URL = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/image_363.png?v=1779712168';
  var PUMP_ICON_URL = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame65.png?v=1741943675';
  function giftIconImg(src) {
    return '<img src="' + src + '" alt="" width="20" height="20" loading="lazy" decoding="async">';
  }
  var SHIPPING_ICON_HTML = giftIconImg(SHIPPING_ICON_URL);
  var LUGGAGE_ICON_HTML = giftIconImg(LUGGAGE_ICON_URL);
  var PUMP_ICON_HTML = giftIconImg(PUMP_ICON_URL);
  var LABELS = {
    '1': '1 Pack',
    '2': 'Buy 1 Get 1 FREE',
    '4': 'Buy 2 Get 2 FREE',
    '6': 'Buy 3 Get 3 FREE'
  };
  /* Control (attribute false) — Liquid defaults; never show Buy titles */
  var DEFAULT_LABELS = {
    '1': '1 Pack',
    '2': '2 Pack',
    '4': '4 Pack',
    '6': '6 Pack'
  };
  var PACK_GIFTS_ATTR = 'data-bundle-messaging-airpump-ab-pack-gifts';
  var timer = null;
  var applying = false;
  var mutating = false;
  var lastEnabled = null;
  var lastKachingInteraction = 0;
  var giftRetryTimer = null;
  var defaultPackSelected = false;
  var userPickedPack = false;

  function withMutating(fn) {
    mutating = true;
    try {
      return fn();
    } finally {
      requestAnimationFrame(function () {
        mutating = false;
      });
    }
  }

  function isAbEnabled() {
    if (!document.body) return false;
    var bodyVal = document.body.getAttribute(ATTR);
    if (bodyVal === 'true') return true;
    if (bodyVal === 'false') return false;
    return document.body.getAttribute('data-bundle-messaging-airpump-ab-setting') === 'true';
  }

  function isConflictingTest() {
    if (!document.body) return false;
    return document.body.getAttribute('data-bundle-selector-ab') === 'true' ||
      document.body.getAttribute('data-bundle-messaging-ab') === 'true';
  }

  function hasKachingBundles() {
    return document.querySelectorAll('.kaching-bundles__bar').length > 0;
  }

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function isBuyTitle(text) {
    var n = normalize(text).toLowerCase();
    return n.indexOf('buy 1 get 1') > -1 ||
      n.indexOf('buy 2 get 2') > -1 ||
      n.indexOf('buy 3 get 3') > -1;
  }

  function detectPackType(text) {
    var n = normalize(text).toLowerCase();
    if (n.indexOf('buy 3 get 3') > -1) return '6';
    if (n.indexOf('buy 2 get 2') > -1) return '4';
    if (n.indexOf('buy 1 get 1') > -1) return '2';
    if (/\b6\s*pack\b/.test(n)) return '6';
    if (/\b4\s*pack\b/.test(n)) return '4';
    if (/\b2\s*pack\b/.test(n)) return '2';
    if (/\b1\s*pack\b/.test(n)) return '1';
    return null;
  }

  function getKachingTitleEl(bar) {
    return bar.querySelector('.kaching-bundles__bar-title') ||
      bar.querySelector('[class*="bar-title"]:not([class*="bar-label"])');
  }

  function getSwatchTitleEl(swatch) {
    return swatch.querySelector('.bundletitle');
  }

  function getDiscountBadge(node) {
    if (!node) return null;

    var badges = node.querySelectorAll(
      '.discount-percentage, .igSavingsPercentage, .main-wrap-label, .green-badge, [class*="bar-badge"], [class*="bar-saving"]'
    );
    var i;
    var badge;

    for (i = 0; i < badges.length; i++) {
      badge = badges[i];
      if (badge.classList.contains('most-popular')) continue;
      if (/\d+%\s*OFF/i.test(normalize(badge.textContent))) return badge;
    }

    return null;
  }

  function applyDiscountBadges() {
    var nodes = [];

    document.querySelectorAll('.variant-picker__option .block-swatch[data-pack-type]').forEach(function (node) {
      nodes.push(node);
    });

    if (hasKachingBundles()) {
      document.querySelectorAll('.kaching-bundles__bar[data-pack-type]').forEach(function (node) {
        nodes.push(node);
      });
    }

    nodes.forEach(function (node) {
      var packType = node.getAttribute(PACK_ATTR);
      if (!packType || packType === '1') return;

      var badge = getDiscountBadge(node);
      if (!badge) return;

      if (!badge.getAttribute(BADGE_ORIGINAL_ATTR)) {
        badge.setAttribute(BADGE_ORIGINAL_ATTR, normalize(badge.textContent));
      }
      if (normalize(badge.textContent) !== VARIANT_B_BADGE) {
        badge.textContent = VARIANT_B_BADGE;
      }
    });
  }

  function restoreDiscountBadges() {
    document.querySelectorAll('[' + BADGE_ORIGINAL_ATTR + ']').forEach(function (badge) {
      var original = badge.getAttribute(BADGE_ORIGINAL_ATTR);
      if (original) badge.textContent = original;
      badge.removeAttribute(BADGE_ORIGINAL_ATTR);
    });
  }

  function getBarPackType(bar, index) {
    var stored = bar.getAttribute(PACK_ATTR);
    if (stored) return stored;

    var titleEl = getKachingTitleEl(bar);
    var fromText = titleEl ? detectPackType(titleEl.textContent) : null;
    if (fromText) return fromText;

    if (bar.classList.contains('block-swatch--pack-6')) return '6';

    var bars = document.querySelectorAll('.kaching-bundles__bar');
    if (bars.length === 2) {
      return index === 0 ? '2' : '4';
    }
    if (bars.length === 4) {
      return index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : '6';
    }

    return index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : index === 3 ? '6' : null;
  }

  function tagPackNodes() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    var i;
    var packType;

    for (i = 0; i < bars.length; i++) {
      packType = getBarPackType(bars[i], i);
      if (packType) bars[i].setAttribute(PACK_ATTR, packType);
    }

    document.querySelectorAll('.variant-picker__option').forEach(function (fieldset) {
      if (!fieldset.querySelector('.bundletitle')) return;
      fieldset.querySelectorAll('.block-swatch').forEach(function (swatch, index) {
        var titleEl = getSwatchTitleEl(swatch);
        var type = titleEl ? detectPackType(titleEl.textContent) : null;
        if (!type) {
          if (swatch.classList.contains('block-swatch--pack-6')) type = '6';
          else if (swatch.classList.contains('block-swatch--pack-4')) type = '4';
          else if (swatch.classList.contains('block-swatch--pack-2')) type = '2';
          else if (swatch.classList.contains('block-swatch--pack-1')) type = '1';
        }
        if (!type) {
          var count = fieldset.querySelectorAll('.block-swatch').length;
          if (count === 2) type = index === 0 ? '2' : '4';
          else if (count === 4) type = index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : '6';
          else type = index === 0 ? '1' : index === 1 ? '2' : index === 2 ? '4' : index === 3 ? '6' : null;
        }
        if (type) swatch.setAttribute(PACK_ATTR, type);
      });
    });
  }

  function getPackSixHosts() {
    return document.querySelectorAll(
      '.kaching-bundles__bar[data-pack-type="6"], ' +
      '.variant-picker__option .block-swatch[data-pack-type="6"], ' +
      '.variant-picker__option .block-swatch--pack-6'
    );
  }

  function getPackOneHosts() {
    return document.querySelectorAll(
      '.kaching-bundles__bar[data-pack-type="1"], ' +
      '.variant-picker__option .block-swatch[data-pack-type="1"], ' +
      '.variant-picker__option .block-swatch--pack-1'
    );
  }

  function setSixPackVisibility(show) {
    getPackSixHosts().forEach(function (node) {
      if (show) {
        node.removeAttribute('aria-hidden');
        node.classList.remove(SIX_HIDDEN_CLASS);
        node.classList.remove('bundle-messaging-ab__six-hidden');
        return;
      }
      node.setAttribute('aria-hidden', 'true');
      node.classList.add(SIX_HIDDEN_CLASS);
    });
  }

  /** When airpump AB is on: hide 1 Pack. When off: show 1 Pack. */
  function setOnePackVisibility(show) {
    getPackOneHosts().forEach(function (node) {
      if (show) {
        node.removeAttribute('aria-hidden');
        node.classList.remove(ONE_HIDDEN_CLASS);
        return;
      }
      node.setAttribute('aria-hidden', 'true');
      node.classList.add(ONE_HIDDEN_CLASS);
    });
  }

  function getPackTypeFromHost(host) {
    if (!host) return null;
    var stored = host.getAttribute(PACK_ATTR);
    if (stored) return stored;
    if (host.classList.contains('block-swatch--pack-6')) return '6';
    if (host.classList.contains('block-swatch--pack-4')) return '4';
    if (host.classList.contains('block-swatch--pack-2')) return '2';
    if (host.classList.contains('block-swatch--pack-1')) return '1';
    var titleEl = getSwatchTitleEl(host) || getKachingTitleEl(host);
    return titleEl ? detectPackType(titleEl.textContent) : null;
  }

  /**
   * Variant B titles are shown via CSS ::after (font-size:0 on Liquid text).
   * Do NOT rewrite textContent to Buy titles — that causes flicker when the
   * attribute is false / on pack change (Buy text briefly visible).
   */
  function applyLabels() {
    /* no-op: CSS handles Buy titles when attribute is true */
  }

  /** Force Liquid defaults when attribute is false — strip any leftover Buy titles */
  function restoreLabels() {
    withMutating(function () {
      document.querySelectorAll('[' + ORIGINAL_ATTR + ']').forEach(function (el) {
        var original = el.getAttribute(ORIGINAL_ATTR);
        if (original && !isBuyTitle(original)) {
          el.textContent = original;
        }
        el.removeAttribute(ORIGINAL_ATTR);
      });

      document.querySelectorAll('.variant-picker__option .block-swatch').forEach(function (swatch) {
        var packType = getPackTypeFromHost(swatch);
        var titleEl = getSwatchTitleEl(swatch);
        var def = packType ? DEFAULT_LABELS[packType] : null;
        if (!titleEl || !def) return;
        if (isBuyTitle(titleEl.textContent) || normalize(titleEl.textContent) !== def) {
          /* Only rewrite when Buy text leaked; keep Liquid text if already default */
          if (isBuyTitle(titleEl.textContent)) {
            titleEl.textContent = def;
          }
        }
        titleEl.removeAttribute(ORIGINAL_ATTR);
      });

      if (hasKachingBundles()) {
        var bars = document.querySelectorAll('.kaching-bundles__bar');
        bars.forEach(function (bar, index) {
          var packType = bar.getAttribute(PACK_ATTR) || getBarPackType(bar, index);
          var titleEl = getKachingTitleEl(bar);
          var def = packType ? DEFAULT_LABELS[packType] : null;
          if (!titleEl || !def) return;
          if (isBuyTitle(titleEl.textContent)) {
            titleEl.textContent = def;
          }
          titleEl.removeAttribute(ORIGINAL_ATTR);
        });
      }
    });
  }

  function ensureControlState() {
    if (!document.body) return;
    if (isAbEnabled() && !isConflictingTest()) return;
    if (applying || mutating) return;

    applying = true;
    try {
      document.body.classList.remove('bundle-messaging-airpump-ab--active');
      tagPackNodes();
      setSixPackVisibility(false);
      setOnePackVisibility(true);
      restoreLabels();
      restoreDiscountBadges();
      restoreAirPumpGift();
      restorePackSixGifts();
      /* Only bounce off pack 6 when it is selected while hidden — never on normal pack clicks */
      if (!userPickedPack || Date.now() - lastKachingInteraction > 800) {
        fixHiddenPackSelection();
      }
    } finally {
      requestAnimationFrame(function () {
        applying = false;
      });
    }
  }

  function getGiftPackBars() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    var matches = [];
    var i;
    var bar;
    var packType;

    for (i = 0; i < bars.length; i++) {
      bar = bars[i];
      packType = bar.getAttribute(PACK_ATTR) || getBarPackType(bar, i);
      if (packType === '2' || packType === '4' || packType === '6') {
        bar.setAttribute(PACK_ATTR, packType);
        matches.push(bar);
      }
    }

    return matches;
  }

  function isGiftPackHost(host) {
    if (!host) return false;
    if (
      host.classList.contains('block-swatch--pack-2') ||
      host.classList.contains('block-swatch--pack-4') ||
      host.classList.contains('block-swatch--pack-6')
    ) {
      return true;
    }
    var packType = host.getAttribute(PACK_ATTR);
    if (!packType) {
      packType = detectPackType(
        (host.querySelector('.kaching-bundles__bar-title, .bundletitle') || host).textContent
      );
    }
    return packType === '2' || packType === '4' || packType === '6';
  }

  function getGiftPerkLists() {
    var lists = [];
    var seen = [];

    function addList(list) {
      if (!list || seen.indexOf(list) > -1) return;
      seen.push(list);
      lists.push(list);
    }

    getGiftPackBars().forEach(function (bar) {
      bar.querySelectorAll('.bundle-perks').forEach(addList);
    });

    document.querySelectorAll(
      '.block-swatch[data-pack-type="2"] .bundle-perks, ' +
      '.block-swatch[data-pack-type="4"] .bundle-perks, ' +
      '.block-swatch[data-pack-type="6"] .bundle-perks, ' +
      '.block-swatch--pack-2 .bundle-perks, ' +
      '.block-swatch--pack-4 .bundle-perks, ' +
      '.block-swatch--pack-6 .bundle-perks, ' +
      'label.block-swatch--pack-2 .bundle-perks, ' +
      'label.block-swatch--pack-4 .bundle-perks, ' +
      'label.block-swatch--pack-6 .bundle-perks'
    ).forEach(addList);

    document.querySelectorAll('.bundle-perks').forEach(function (list) {
      var host = list.closest('.kaching-bundles__bar, .block-swatch, label');
      if (isGiftPackHost(host)) addList(list);
    });

    return lists;
  }

  function removeAirPumpFromOnePack() {
    document.querySelectorAll('.bundle-perks [' + GIFT_ATTR + '], .bundle-perks .bundle-perk--airpump').forEach(function (el) {
      var host = el.closest('.kaching-bundles__bar, .block-swatch, label');
      if (!host) return;
      if (isGiftPackHost(host)) return;
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function normalizePerkRow(perk) {
    if (!perk || perk.querySelector('.bundle-perk__row')) return;

    var row = document.createElement('span');
    row.className = 'bundle-perk__row';
    row.setAttribute('data-bundle-perk-row', 'true');

    while (perk.firstChild) {
      row.appendChild(perk.firstChild);
    }

    perk.appendChild(row);
  }

  /**
   * Banner markup often has loose icon/text as direct children of .bundle-perks
   * (not wrapped in .bundle-perk). Column flex then stacks icon above text.
   * Wrap consecutive loose parts into .bundle-perk > .bundle-perk__row.
   */
  function wrapLooseBannerParts(list) {
    if (!list) return;

    var hasLoose = false;
    var i;
    for (i = 0; i < list.children.length; i++) {
      var child = list.children[i];
      if (
        child.classList.contains('bundle-perk__icon') ||
        child.classList.contains('bundle-perk__text')
      ) {
        hasLoose = true;
        break;
      }
    }

    if (!hasLoose) {
      Array.prototype.forEach.call(list.children, function (el) {
        if (el.classList && el.classList.contains('bundle-perk')) {
          normalizePerkRow(el);
        }
      });
      return;
    }

    withMutating(function () {
      var nodes = Array.prototype.slice.call(list.childNodes);
      var fragment = document.createDocumentFragment();
      var loose = [];

      function flushLoose() {
        if (!loose.length) return;

        var perk = document.createElement('div');
        perk.className = 'bundle-perk';
        perk.setAttribute('data-bundle-perk-wrapped', 'true');

        var j;
        for (j = 0; j < loose.length; j++) {
          var n = loose[j];
          if (n.nodeType !== 1 || !n.classList) continue;
          if (n.classList.contains('bundle-perk__icon--shipping')) {
            perk.classList.add('bundle-perk--shipping');
          }
          if (n.classList.contains('bundle-perk__icon--luggage')) {
            perk.classList.add('bundle-perk--luggage');
          }
        }

        var row = document.createElement('span');
        row.className = 'bundle-perk__row';
        row.setAttribute('data-bundle-perk-row', 'true');
        for (j = 0; j < loose.length; j++) {
          row.appendChild(loose[j]);
        }
        loose = [];
        perk.appendChild(row);
        fragment.appendChild(perk);
      }

      nodes.forEach(function (node) {
        if (node.nodeType === 3 && !String(node.textContent || '').trim()) return;

        if (
          node.nodeType === 1 &&
          node.classList &&
          node.classList.contains('bundle-perk')
        ) {
          flushLoose();
          normalizePerkRow(node);
          fragment.appendChild(node);
          return;
        }

        loose.push(node);
      });
      flushLoose();

      while (list.firstChild) list.removeChild(list.firstChild);
      list.appendChild(fragment);
      list.setAttribute('data-bundle-perks-normalized', 'true');
    });
  }

  function normalizeGiftPerkRows() {
    getGiftPerkLists().forEach(wrapLooseBannerParts);
  }

  function buildAirPumpPerk(list) {
    var template = list.querySelector('.bundle-perk--luggage') ||
      list.querySelector('.bundle-perk--shipping') ||
      list.querySelector('.bundle-perk');
    var perk;

    if (template) {
      perk = template.cloneNode(true);
      perk.className = 'bundle-perk bundle-perk--airpump';
      perk.setAttribute(GIFT_ATTR, 'true');
      perk.removeAttribute('data-bundle-perk-wrapped');

      var existingRow = perk.querySelector('.bundle-perk__row');
      if (existingRow) {
        while (existingRow.firstChild) perk.appendChild(existingRow.firstChild);
        if (existingRow.parentNode) existingRow.parentNode.removeChild(existingRow);
      }

      var icon = perk.querySelector('.bundle-perk__icon');
      if (icon) {
        icon.className = 'bundle-perk__icon bundle-perk__icon--airpump';
        var img = icon.querySelector('img');
        if (img) {
          img.src = PUMP_ICON_URL;
          img.alt = '';
          img.width = 20;
          img.height = 20;
        }
      }

      var text = perk.querySelector('.bundle-perk__text');
      if (text) text.textContent = GIFT_TEXT;
      else {
        var span = document.createElement('span');
        span.className = 'bundle-perk__text';
        span.textContent = GIFT_TEXT;
        perk.appendChild(span);
      }

      normalizePerkRow(perk);
      return perk;
    }

    perk = document.createElement('div');
    perk.className = 'bundle-perk bundle-perk--airpump';
    perk.setAttribute(GIFT_ATTR, 'true');
    perk.innerHTML =
      '<span class="bundle-perk__row" data-bundle-perk-row="true">' +
      '<span class="bundle-perk__icon bundle-perk__icon--airpump">' +
      '<img src="' + PUMP_ICON_URL + '" alt="" width="20" height="20" loading="lazy" decoding="async">' +
      '</span>' +
      '<span class="bundle-perk__text">' + GIFT_TEXT + '</span>' +
      '</span>';
    return perk;
  }

  function getSourceGiftList() {
    var selectors = [
      '.kaching-bundles__bar[data-pack-type="4"] .bundle-perks',
      '.kaching-bundles__bar[data-pack-type="4"] .kaching-bundles__bar-subtitles',
      '.kaching-bundles__bar[data-pack-type="4"] .kaching-bundles__bar-subtitle-list',
      '.block-swatch[data-pack-type="4"] .bundle-perks',
      '.block-swatch--pack-4 .bundle-perks'
    ];
    var i;
    var list;
    for (i = 0; i < selectors.length; i++) {
      list = document.querySelector(selectors[i]);
      if (list) return list;
    }
    return null;
  }

  function buildPerkHtml(kind, text, iconHtml) {
    return (
      '<div class="bundle-perk bundle-perk--' + kind + '">' +
      '<span class="bundle-perk__row" data-bundle-perk-row="true">' +
      '<span class="bundle-perk__icon bundle-perk__icon--' + kind + '" aria-hidden="true">' +
      iconHtml +
      '</span>' +
      '<span class="bundle-perk__text">' + text + '</span>' +
      '</span></div>'
    );
  }

  function buildGiftListMarkup(includeLuggage) {
    var html = buildPerkHtml('shipping', '+ Free Shipping', SHIPPING_ICON_HTML);
    if (includeLuggage) {
      html += buildPerkHtml('luggage', '+ Free Luggage Tag ($97 Value)', LUGGAGE_ICON_HTML);
    }
    html +=
      '<div class="bundle-perk bundle-perk--airpump" ' + GIFT_ATTR + '="true">' +
      '<span class="bundle-perk__row" data-bundle-perk-row="true">' +
      '<span class="bundle-perk__icon bundle-perk__icon--airpump">' +
      PUMP_ICON_HTML +
      '</span>' +
      '<span class="bundle-perk__text">' + GIFT_TEXT + '</span>' +
      '</span></div>';
    return html;
  }

  function buildFallbackPackSixGiftList() {
    var list = document.createElement('div');
    list.className = 'bundle-perks bundle-perks--banner bundle-messaging-airpump-ab__pack6-gifts';
    list.setAttribute(PACK6_GIFTS_ATTR, 'true');
    list.setAttribute(PACK_GIFTS_ATTR, '6');
    list.innerHTML = buildGiftListMarkup(true);
    return list;
  }

  function buildPackGiftList(packType) {
    var list = document.createElement('div');
    list.className = 'bundle-perks bundle-perks--banner bundle-messaging-airpump-ab__pack-gifts';
    list.setAttribute(PACK_GIFTS_ATTR, packType);
    if (packType === '6') {
      list.setAttribute(PACK6_GIFTS_ATTR, 'true');
      list.classList.add('bundle-messaging-airpump-ab__pack6-gifts');
    }
    /* Pack 2 (Buy 1 Get 1): shipping + air pump. Pack 4/6: all three. */
    list.innerHTML = buildGiftListMarkup(packType !== '2');
    return list;
  }

  function upgradeGreySvgIcons(list) {
    if (!list) return;
    list.querySelectorAll('.bundle-perk__icon--shipping').forEach(function (icon) {
      var img = icon.querySelector('img');
      if (!img || img.getAttribute('src') !== SHIPPING_ICON_URL) {
        icon.innerHTML = SHIPPING_ICON_HTML;
      }
    });
    list.querySelectorAll('.bundle-perk__icon--luggage').forEach(function (icon) {
      var img = icon.querySelector('img');
      if (!img || img.getAttribute('src') !== LUGGAGE_ICON_URL) {
        icon.innerHTML = LUGGAGE_ICON_HTML;
      }
    });
    list.querySelectorAll('.bundle-perk__icon--airpump').forEach(function (icon) {
      var img = icon.querySelector('img');
      if (!img || img.getAttribute('src') !== PUMP_ICON_URL) {
        icon.innerHTML = PUMP_ICON_HTML;
      }
    });
  }

  function getPackGiftMount(host) {
    return getPackSixGiftMount(host);
  }

  function placePackGifts(host, gifts) {
    var mount = getPackGiftMount(host);
    if (host.classList.contains('block-swatch--pack-6') || host.getAttribute(PACK_ATTR) === '6') {
      host.classList.add(PACK6_CARD_CLASS);
    }

    if (gifts.parentNode) gifts.parentNode.removeChild(gifts);

    if (mount.after && mount.after.parentNode === mount.parent) {
      if (mount.after.nextSibling) {
        mount.parent.insertBefore(gifts, mount.after.nextSibling);
      } else {
        mount.parent.appendChild(gifts);
      }
    } else {
      mount.parent.appendChild(gifts);
    }
  }

  function getGiftPackHosts() {
    return document.querySelectorAll(
      '.variant-picker__option .block-swatch[data-pack-type="2"], ' +
      '.variant-picker__option .block-swatch[data-pack-type="4"], ' +
      '.variant-picker__option .block-swatch[data-pack-type="6"], ' +
      '.variant-picker__option .block-swatch--pack-2, ' +
      '.variant-picker__option .block-swatch--pack-4, ' +
      '.variant-picker__option .block-swatch--pack-6, ' +
      '.kaching-bundles__bar[data-pack-type="2"], ' +
      '.kaching-bundles__bar[data-pack-type="4"], ' +
      '.kaching-bundles__bar[data-pack-type="6"]'
    );
  }

  function getHostPackType(host) {
    if (!host) return null;
    var stored = host.getAttribute(PACK_ATTR);
    if (stored) return stored;
    if (host.classList.contains('block-swatch--pack-6')) return '6';
    if (host.classList.contains('block-swatch--pack-4')) return '4';
    if (host.classList.contains('block-swatch--pack-2')) return '2';
    return detectPackType(
      (host.querySelector('.kaching-bundles__bar-title, .bundletitle') || host).textContent
    );
  }

  function ensurePackGifts() {
    if (!isAbEnabled() || isConflictingTest()) {
      restorePackSixGifts();
      restoreInjectedPackGifts();
      return;
    }

    withMutating(function () {
      getGiftPackHosts().forEach(function (host) {
        if (host.getAttribute('aria-hidden') === 'true') return;

        var packType = getHostPackType(host);
        if (packType !== '2' && packType !== '4' && packType !== '6') return;
        host.setAttribute(PACK_ATTR, packType);

        var existing =
          host.querySelector('[' + PACK_GIFTS_ATTR + ']') ||
          host.querySelector('[' + PACK6_GIFTS_ATTR + ']');
        if (existing) {
          upgradeGreySvgIcons(existing);
          if (!existing.querySelector('[' + GIFT_ATTR + '], .bundle-perk--airpump')) {
            existing.appendChild(buildAirPumpPerk(existing));
          }
          placePackGifts(host, existing);
          wrapLooseBannerParts(existing);
          return;
        }

        var nativePerks = host.querySelector('.bundle-perks:not([' + PACK_GIFTS_ATTR + ']):not([' + PACK6_GIFTS_ATTR + '])');
        if (nativePerks) {
          upgradeGreySvgIcons(nativePerks);
          if (!nativePerks.querySelector('[' + GIFT_ATTR + '], .bundle-perk--airpump')) {
            nativePerks.appendChild(buildAirPumpPerk(nativePerks));
          }
          /* Pack 2 should not keep luggage if present from a cloned 4-pack list */
          if (packType === '2') {
            nativePerks.querySelectorAll('.bundle-perk--luggage').forEach(function (el) {
              if (el.parentNode) el.parentNode.removeChild(el);
            });
          }
          wrapLooseBannerParts(nativePerks);
          placePackGifts(host, nativePerks);
          return;
        }

        var gifts = buildPackGiftList(packType);
        placePackGifts(host, gifts);
        wrapLooseBannerParts(gifts);
      });
    });
  }

  function restoreInjectedPackGifts() {
    withMutating(function () {
      document.querySelectorAll('[' + PACK_GIFTS_ATTR + ']').forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    });
  }

  function getPackSixGiftMount(host) {
    // Place gifts as a sibling BELOW .swatch-wrap (same as pack 2/4),
    // not inside .swatch-wrap (row flex squeezes the header).
    var swatchWrap = host.querySelector(':scope > .swatch-wrap') || host.querySelector('.swatch-wrap');
    if (swatchWrap) {
      return { parent: swatchWrap.parentNode || host, after: swatchWrap };
    }
    var mainWrap = host.querySelector('.main-wrap');
    if (mainWrap && mainWrap.parentNode) {
      return { parent: mainWrap.parentNode, after: mainWrap };
    }
    var barContent = host.querySelector('.kaching-bundles__bar-container, .kaching-bundles__bar-content');
    if (barContent) {
      return { parent: barContent.parentNode || host, after: barContent };
    }
    return { parent: host, after: null };
  }

  function placePackSixGifts(host, gifts) {
    placePackGifts(host, gifts);
  }

  function ensurePackSixGifts() {
    ensurePackGifts();
  }

  function restorePackSixGifts() {
    withMutating(function () {
      document.querySelectorAll('[' + PACK6_GIFTS_ATTR + '], [' + PACK_GIFTS_ATTR + ']').forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      document.querySelectorAll('.' + PACK6_CARD_CLASS).forEach(function (el) {
        el.classList.remove(PACK6_CARD_CLASS);
      });
    });
  }

  function applyAirPumpGift() {
    if (!isAbEnabled() || isConflictingTest()) {
      restoreAirPumpGift();
      restorePackSixGifts();
      return;
    }

    withMutating(function () {
      removeAirPumpFromOnePack();
      normalizeGiftPerkRows();

      getGiftPerkLists().forEach(function (list) {
        if (list.querySelector('[' + GIFT_ATTR + '], .bundle-perk--airpump')) return;
        list.appendChild(buildAirPumpPerk(list));
      });

      normalizeGiftPerkRows();
    });

    ensurePackSixGifts();
  }

  function restoreAirPumpGift() {
    withMutating(function () {
      document.querySelectorAll('[' + GIFT_ATTR + '], .bundle-perk--airpump').forEach(function (el) {
        if (el.closest('[' + PACK6_GIFTS_ATTR + ']')) return;
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    });
  }

  function retryAirPumpGift() {
    if (!isAbEnabled() || isConflictingTest()) {
      restoreAirPumpGift();
      restorePackSixGifts();
      setSixPackVisibility(false);
      setOnePackVisibility(true);
      return;
    }
    if (giftRetryTimer) clearTimeout(giftRetryTimer);
    giftRetryTimer = setTimeout(function () {
      if (applying || mutating) return;
      if (!isAbEnabled() || isConflictingTest()) {
        restoreAirPumpGift();
        restorePackSixGifts();
        setSixPackVisibility(false);
        setOnePackVisibility(true);
        return;
      }
      tagPackNodes();
      setSixPackVisibility(true);
      setOnePackVisibility(false);
      applyAirPumpGift();
    }, 80);
  }

  function saveScrollState() {
    var pageX = window.scrollX || window.pageXOffset || 0;
    var pageY = window.scrollY || window.pageYOffset || 0;
    var areas = [];
    document.querySelectorAll('.variant-picker__option-values, .scroll-area, .kaching-bundles__bars').forEach(function (el) {
      if (!el) return;
      areas.push({ el: el, left: el.scrollLeft, top: el.scrollTop });
    });
    return { pageX: pageX, pageY: pageY, areas: areas };
  }

  function restoreScrollState(state) {
    if (!state) return;
    state.areas.forEach(function (item) {
      if (!item.el) return;
      item.el.scrollLeft = item.left;
      item.el.scrollTop = item.top;
    });
    window.scrollTo(state.pageX, state.pageY);
  }

  /** Select a pack radio/label without focusing or scrolling the page */
  function selectPackQuietly(swatch) {
    if (!swatch) return false;
    var scrollState = saveScrollState();
    var radio = swatch.previousElementSibling;
    if (!(radio && radio.type === 'radio')) {
      var inputId = swatch.getAttribute('for');
      radio = inputId ? document.getElementById(inputId) : null;
      if (!radio) radio = swatch.querySelector('input[type="radio"]');
    }

    if (radio && radio.type === 'radio') {
      if (!radio.checked) {
        radio.checked = true;
        try {
          radio.dispatchEvent(new Event('input', { bubbles: true }));
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) { /* ignore */ }
      }
      restoreScrollState(scrollState);
      requestAnimationFrame(function () {
        restoreScrollState(scrollState);
      });
      return true;
    }

    /* Fallback: click but restore scroll immediately after */
    try { swatch.click(); } catch (e2) { /* ignore */ }
    restoreScrollState(scrollState);
    requestAnimationFrame(function () {
      restoreScrollState(scrollState);
    });
    return true;
  }

  function selectDefaultFirstPack() {
    /* Default pack on load — never after the shopper picks another pack */
    if (userPickedPack || defaultPackSelected) return;
    if (isConflictingTest()) return;

    tagPackNodes();

    var scrollState = saveScrollState();
    var enabled = isAbEnabled();
    /* Variant B hides 1 Pack → default to 2 Pack. Control → 1 Pack. */
    var defaultType = enabled ? '2' : '1';

    var firstBar = document.querySelector('.kaching-bundles__bar[data-pack-type="' + defaultType + '"]');
    if (firstBar) {
      if (!firstBar.classList.contains('kaching-bundles__bar--selected')) {
        var clickEl =
          firstBar.querySelector('.kaching-bundles__bar-container') ||
          firstBar.querySelector('[role="button"]') ||
          firstBar;
        try {
          clickEl.click();
        } catch (e) { /* ignore */ }
      }
      if (firstBar.classList.contains('kaching-bundles__bar--selected')) {
        defaultPackSelected = true;
      }
      restoreScrollState(scrollState);
      return;
    }

    var firstSwatch =
      document.querySelector('.variant-picker__option .block-swatch[data-pack-type="' + defaultType + '"]') ||
      document.querySelector('.variant-picker__option .block-swatch--pack-' + defaultType) ||
      document.querySelector('.bundle-pack-picker .block-swatch--pack-' + defaultType);

    if (firstSwatch) {
      selectPackQuietly(firstSwatch);
      defaultPackSelected = true;
      restoreScrollState(scrollState);
      return;
    }

    var firstInput =
      document.querySelector('.bundle-pack-picker input[data-pack-type="' + defaultType + '"]') ||
      document.querySelector('.bundle-pack-picker input[type="radio"]');

    if (firstInput && firstInput.tagName === 'INPUT') {
      if (!firstInput.checked) {
        firstInput.checked = true;
        firstInput.dispatchEvent(new Event('input', { bubbles: true }));
        firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      defaultPackSelected = !!firstInput.checked;
      restoreScrollState(scrollState);
    }
  }

  function isPackNodeSelected(node) {
    if (!node) return false;
    if (node.classList.contains('kaching-bundles__bar--selected') || node.classList.contains('is-selected')) {
      return true;
    }
    var inputId = node.getAttribute('for');
    var radio = node.querySelector('input[type="radio"]') ||
      (inputId ? document.getElementById(inputId) : null) ||
      node.previousElementSibling;
    return !!(radio && radio.type === 'radio' && radio.checked);
  }

  function fixHiddenPackSelection() {
    if (userPickedPack) return;

    var scrollState = saveScrollState();
    var enabled = isAbEnabled() && !isConflictingTest();

    if (enabled) {
      /* 1 Pack is hidden — if selected, move to 2 Pack */
      var oneSelected = false;
      getPackOneHosts().forEach(function (node) {
        if (isPackNodeSelected(node)) oneSelected = true;
      });
      if (oneSelected) {
        var pack2 =
          document.querySelector('.block-swatch[data-pack-type="2"]') ||
          document.querySelector('.block-swatch--pack-2') ||
          document.querySelector('.kaching-bundles__bar[data-pack-type="2"]');
        if (pack2) {
          if (pack2.classList.contains('kaching-bundles__bar')) {
            var clickEl =
              pack2.querySelector('.kaching-bundles__bar-container') ||
              pack2.querySelector('[role="button"]') ||
              pack2;
            try { clickEl.click(); } catch (e) { /* ignore */ }
          } else {
            selectPackQuietly(pack2);
          }
        }
      }
      restoreScrollState(scrollState);
      return;
    }

    /* Control: 6 Pack hidden — if selected, move to 1 Pack */
    var sixSelected = false;
    getPackSixHosts().forEach(function (node) {
      if (isPackNodeSelected(node)) sixSelected = true;
    });
    if (!sixSelected) return;

    var firstSwatch =
      document.querySelector('.block-swatch[data-pack-type="1"]') ||
      document.querySelector('.block-swatch--pack-1');
    if (firstSwatch) {
      selectPackQuietly(firstSwatch);
    } else {
      var firstBar = document.querySelector('.kaching-bundles__bar[data-pack-type="1"]');
      if (firstBar) {
        var clickEl2 =
          firstBar.querySelector('.kaching-bundles__bar-container') ||
          firstBar.querySelector('[role="button"]') ||
          firstBar;
        try { clickEl2.click(); } catch (e2) { /* ignore */ }
      }
    }
    restoreScrollState(scrollState);
  }

  function applyTest() {
    if (applying || mutating) return;
    applying = true;

    try {
      var enabled = isAbEnabled() && !isConflictingTest();

      if (lastEnabled !== enabled) {
        lastEnabled = enabled;
        if (!userPickedPack) defaultPackSelected = false;
      }

      document.body.classList.toggle('bundle-messaging-airpump-ab--active', enabled);

      tagPackNodes();
      setSixPackVisibility(enabled);
      setOnePackVisibility(!enabled);

      if (!enabled) {
        restoreLabels();
        restoreDiscountBadges();
        restoreAirPumpGift();
        restorePackSixGifts();
        if (!userPickedPack) {
          fixHiddenPackSelection();
          selectDefaultFirstPack();
        }
        return;
      }

      applyDiscountBadges();
      applyAirPumpGift();
      if (!userPickedPack) {
        fixHiddenPackSelection();
        selectDefaultFirstPack();
      }
    } finally {
      requestAnimationFrame(function () {
        applying = false;
      });
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(applyTest, 0);
  }

  function reapplyTitlesNow() {
    if (!isAbEnabled() || isConflictingTest()) {
      ensureControlState();
      return;
    }
    tagPackNodes();
    setSixPackVisibility(true);
    setOnePackVisibility(false);
    applyDiscountBadges();
  }

  function onPackPick(event) {
    if (event.target.closest('.kaching-bundles__bar, kaching-bundles-block, kaching-bundle, .block-swatch, .bundle-perks')) {
      lastKachingInteraction = Date.now();
      userPickedPack = true;
      defaultPackSelected = true;
      var scrollState = saveScrollState();
      if (!isAbEnabled() || isConflictingTest()) {
        requestAnimationFrame(function () {
          restoreScrollState(scrollState);
          /* Control refresh without jumping selection or scrolling */
          if (applying || mutating) return;
          applying = true;
          try {
            document.body.classList.remove('bundle-messaging-airpump-ab--active');
            tagPackNodes();
            setSixPackVisibility(false);
            setOnePackVisibility(true);
            restoreLabels();
            restoreDiscountBadges();
            restoreAirPumpGift();
            restorePackSixGifts();
          } finally {
            requestAnimationFrame(function () {
              applying = false;
              restoreScrollState(scrollState);
            });
          }
        });
        return;
      }
      reapplyTitlesNow();
      requestAnimationFrame(function () {
        reapplyTitlesNow();
        retryAirPumpGift();
        ensurePackSixGifts();
        restoreScrollState(scrollState);
      });
    }
  }

  function onVariantUpdate() {
    if (!isAbEnabled() || isConflictingTest()) {
      requestAnimationFrame(function () {
        if (userPickedPack) {
          /* Keep selection; only clean titles/gifts/hide pack 6 */
          if (applying || mutating) return;
          applying = true;
          try {
            document.body.classList.remove('bundle-messaging-airpump-ab--active');
            tagPackNodes();
            setSixPackVisibility(false);
            setOnePackVisibility(true);
            restoreLabels();
            restoreDiscountBadges();
            restoreAirPumpGift();
            restorePackSixGifts();
          } finally {
            requestAnimationFrame(function () {
              applying = false;
            });
          }
          return;
        }
        ensureControlState();
      });
      schedule();
      return;
    }
    reapplyTitlesNow();
    schedule();
  }

  function isOurMutationNode(node) {
    if (!node || node.nodeType !== 1) return true;
    if (node.getAttribute && node.getAttribute(GIFT_ATTR) === 'true') return true;
    if (node.hasAttribute && node.hasAttribute('data-bundle-perk-row')) return true;
    if (node.hasAttribute && node.hasAttribute('data-bundle-perk-wrapped')) return true;
    if (node.hasAttribute && node.hasAttribute('data-bundle-perks-normalized')) return true;
    if (node.classList) {
      if (
        node.classList.contains('bundle-perk--airpump') ||
        node.classList.contains('bundle-perk__row') ||
        node.classList.contains('bundle-airpump-gift')
      ) {
        return true;
      }
    }
    return false;
  }

  function isKachingRerenderNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (isOurMutationNode(node)) return false;
    if (
      node.matches &&
      node.matches(
        'kaching-bundles-block, kaching-bundle, kaching-bundles, .kaching-bundles__bar, variant-picker, .bundletitle, .block-swatch--pack-1, .block-swatch--pack-2, .block-swatch--pack-4, .block-swatch--pack-6'
      )
    ) {
      return true;
    }
    if (
      node.querySelector &&
      node.querySelector(
        'kaching-bundles-block, kaching-bundle, .kaching-bundles__bar, .bundletitle, .block-swatch--pack-1, .block-swatch--pack-2, .block-swatch--pack-4, .block-swatch--pack-6'
      )
    ) {
      return true;
    }
    /* Banner re-injected with loose shipping icon/text (not our wrapped perk) */
    if (
      node.matches &&
      node.matches('.bundle-perks') &&
      node.querySelector(':scope > .bundle-perk__icon, :scope > .bundle-perk__text')
    ) {
      return true;
    }
    return false;
  }

  function init() {
    applyTest();

    document.addEventListener('click', onPackPick, true);
    document.addEventListener('variant:change', onVariantUpdate);
    document.addEventListener('product:rerender', onVariantUpdate);

    new MutationObserver(function (mutations) {
      if (applying || mutating) return;
      var run = false;
      mutations.forEach(function (m) {
        if (
          m.attributeName === ATTR ||
          m.attributeName === 'data-bundle-selector-ab' ||
          m.attributeName === 'data-bundle-messaging-ab'
        ) {
          run = true;
        }
      });
      if (run) schedule();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [ATTR, 'data-bundle-selector-ab', 'data-bundle-messaging-ab']
    });

    new MutationObserver(function (mutations) {
      if (applying || mutating) return;

      var run = false;
      var i;
      var j;
      var node;
      for (i = 0; i < mutations.length; i++) {
        if (mutations[i].type !== 'childList' || !mutations[i].addedNodes.length) continue;
        for (j = 0; j < mutations[i].addedNodes.length; j++) {
          node = mutations[i].addedNodes[j];
          if (isKachingRerenderNode(node)) {
            run = true;
            break;
          }
        }
        if (run) break;
      }
      if (run) {
        if (!isAbEnabled() || isConflictingTest()) {
          if (userPickedPack) {
            if (applying || mutating) return;
            applying = true;
            try {
              tagPackNodes();
              setSixPackVisibility(false);
              setOnePackVisibility(true);
              restoreLabels();
              restoreDiscountBadges();
              restoreAirPumpGift();
              restorePackSixGifts();
            } finally {
              requestAnimationFrame(function () {
                applying = false;
              });
            }
          } else {
            ensureControlState();
          }
        } else {
          reapplyTitlesNow();
          retryAirPumpGift();
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll('kaching-bundles-block').forEach(function (block) {
      block.addEventListener('deal-bar-selected', retryAirPumpGift);
    });

    [100, 400, 800, 1500].forEach(function (ms) {
      setTimeout(function () {
        if (!applying && !mutating) applyTest();
      }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    if (!applying && !mutating) applyTest();
  });

  window.AerlessBundleMessagingAirpumpAb = {
    refresh: applyTest,
    isEnabled: isAbEnabled,
    reset: function () {
      applyTest();
    }
  };
})();
